<ion-content class="ion-no-padding no-scrollbar">
  <ion-grid class="ion-no-padding store-wrapper">
    <ion-row>
      <ion-card class="store-card"
        [ngStyle]="{ 'background': slidesElement?.slideDetails?.slide_up?.gradient_left ?? slidesElement?.slideDetails?.slide_info?.background }">
        <ion-row class="offer-lottery-icons">
          <div>
            <img src="{{slidesElement?.slideDetails?.slider?.product_lottery_icon_1}}" />
          </div>
          <div class="lottery-seperate-icons" *ngIf="slidesElement?.slideDetails?.slider?.product_lottery_icon_2">
            +
          </div>
          <div>
            <img src="{{slidesElement?.slideDetails?.slider?.product_lottery_icon_2}}" />
          </div>
        </ion-row>
      </ion-card>
      <h1 class="slide-title">{{ 
        slidesElement?.slideDetails?.slide_up?.popup_title}}
      </h1>
    </ion-row>
    @if (slidesElement?.slideDetails?.slide_info?.style === flashSaleStyleString) {
      <ion-row>
        <h4 class="syndicate-header" [innerHTML]="slidesElement?.slideDetails?.slide_up?.content?.[languageCode]?.popup_title"></h4>
      </ion-row>
      <ion-row>
        <h4 class="syndicate-header" [innerHTML]="slidesElement?.slideDetails?.slide_up?.content?.[languageCode]?.description"></h4>
      </ion-row>
    }
    @else {
      <ion-row>
        <h4 class="syndicate-header">Here’s the deal:</h4>
      </ion-row>
      <div class="syndicate-keys">
        <div *ngFor="let offer of slideUpDetails" class="syndicate-detail-wraper offer-description">
          <ion-icon name="checkmark" class="tick-mark"></ion-icon>
          <span class="syndicate-hints" [innerHTML]="offer"> </span>
        </div>
      </div>
    }
    <ion-button expand="block" color="secondary" class="capsule-btn common-margin syndicate-btn"
      (click)="makePayment()">{{ slidesElement?.slideDetails?.slide_info?.style === 'flash_sale' ? slidesElement?.slideDetails?.slider?.content?.[languageCode]?.button_label : 'offerofdaydetail.Join' | translate}}</ion-button>
    <p class="back-arrow" (click)="back()"><span class="arrow">←</span> {{'offerofdaydetail.Back' | translate}}</p>
  </ion-grid>
</ion-content>
